class Controller {
  constructor($mdDialog) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.selected = {};
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    this.$mdDialog.hide(this.selected);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/route/dispatchDialog/dispatchDialog.controller.js